import * as React from "react"
import Layout from "../components/layout"
import Button from "../components/button"
import Card from "../components/card"
import SimpleSlider from "../components/carousel_test"
import { StaticImage } from "gatsby-plugin-image"

import whiteRingLogo from "../images/DocentToad_Logo_white-ring.svg"

function Explore() {
    return(
     <Layout>
         <SimpleSlider>hi</SimpleSlider>
        <Button>this is a test</Button>
        <Card 
            ph={<StaticImage src="../images/test-thumb.jpg"/>}
            title="test title" 
            description="this is how the world ends"/>

        <img src={whiteRingLogo} className="fill-current text-black" />
     </Layout>
    )
}

export default Explore   